import '.d{display:flex;}.ssr-plugin'
import '.b1{aspect-ratio:1/1;}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.b2{padding:0.5rem;}.ssr-plugin'
import '.an{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import {
  faCheck,
  faWarning,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

export type Variant = 'success' | 'error'

const variantStyle: Record<Variant, Style> = {
  success: {
    color: 'var(--status-success-muted)',
    background: 'var(--status-success-vivid)',
  },
  error: {
    color: 'var(--palette-red-200)',
    background: 'var(--status-error)',
  },
}

const iconVariant: Record<Variant, IconDefinition> = {
  success: faCheck,
  error: faWarning,
}

export type IconProps = {
  variant: Variant
  icon?: IconDefinition
}

export const ToastIcon = ({ variant }: IconProps) => {
  const isMobile = useMediaQuery()
  return (
    <styled.div className="d b1 ar b2 an r"
      style={{
        width: isMobile ? '2.75rem' : '3.5rem',
        height: isMobile ? '2.75rem' : '3.5rem',
        borderRadius: isMobile ? '0.75rem' : '1rem',
        ...variantStyle[variant],
      }}
    >
      <FontAwesomeIcon
        icon={iconVariant[variant]}
        fontSize={isMobile ? '1.5rem' : '2.125rem'}
      />
    </styled.div>
  )
}
